module.exports = __webpack_public_path__ + "img/havi.4419d41c.jpg";